import "@fortawesome/fontawesome-pro/css/all.css";
import { createPinia } from "pinia";
import { createApp } from "vue";

import AvtalatUI from "@avtalat/kaf-ui-components";
import "@avtalat/kaf-ui-components/dist/kaf-ui-components.css";

import "@/assets/kundservice.css";

import App from "./App.vue";
import router from "./router";
import { useAuthStore } from "./stores/authStore";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(AvtalatUI);

(async () => {
  await useAuthStore().init();
  // Waiting for the router to be ready prevents race conditions when returning from a loginRedirect or acquireTokenRedirect
  await router.isReady();

  app.mount("#app");
})();
